module.exports = __webpack_public_path__ + "img/activity_4_5_6_tile_image.c1286f47.jpg";